import { render } from "./Patients.vue?vue&type=template&id=2c1186a5"
import script from "./Patients.vue?vue&type=script&lang=js"
export * from "./Patients.vue?vue&type=script&lang=js"
script.render = render

export default script